
















































import Video from '@/components/common/Video.vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
@Component({
  components: {
    Swiper,
    SwiperSlide,
    Video
  }
})
export default class extends Vue {
  // 接收参数
  @Prop() public data!: object;
  @Prop() public isActive!: boolean;

  get pageData() {
    if ((this.data as any).companyShow) {
      return this.data;
    }
    return {
      companyShow: {},
      busShowList: []
    };
  }

  @Watch('isActive')
  activeChange(val) {
    if (!val) {
      if (this.$refs.introVideo) {
        (this.$refs.introVideo as any).suspendVideo();
      }
    }
  }
}
